import { render, staticRenderFns } from "./visit-cap.vue?vue&type=template&id=04dc9d0c&scoped=true&"
import script from "./visit-cap.vue?vue&type=script&lang=ts&"
export * from "./visit-cap.vue?vue&type=script&lang=ts&"
import style0 from "./visit-cap.vue?vue&type=style&index=0&id=04dc9d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc9d0c",
  null
  
)

export default component.exports